module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Jack Compton’s Luck")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "titlePage",
    attrs: {
      "id": "tp01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page03"
    }
  }, [_c('h2', {
    staticClass: "titlePageAuthor"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Paula Marshall")])])])])]), _c('h2', {
    staticClass: "titlePageTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("J"), _c('span', {
    staticClass: "smallCaps1"
  }, [_c('span', [_vm._v("ACK")])]), _vm._v(" C"), _c('span', {
    staticClass: "smallCaps1"
  }, [_c('span', [_vm._v("OMPTON’S")])]), _vm._v(" L"), _c('span', {
    staticClass: "smallCaps1"
  }, [_c('span', [_vm._v("UCK")])])])])]), _c('p', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/logo.jpg"
    }
  })])]), _c('p', {
    staticClass: "titlePageCity"
  }, [_c('span', [_c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("TORONTO • NEW YORK • LONDON"), _c('br'), _vm._v("\nAMSTERDAM • PARIS • SYDNEY • HAMBURG"), _c('br'), _vm._v("\nSTOCKHOLM • ATHENS • TOKYO • MILAN • MADRID"), _c('br'), _vm._v("\nPRAGUE • WARSAW • BUDAPEST • AUCKLAND")])])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page03"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f8ed398","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jackcomptonsluck_tp01.vue
// module id = 63
// module chunks = 0